// extracted by mini-css-extract-plugin
export default {"btn":"DnS8a0ONCFiyJKIcJ7zl"};